import React from 'react';
import { SubscriberGroupsTranslation } from 'app/area/subscriber-groups/constants';
import styles from './external-members-list-heading.scss';

export const ExternalMembersListHeading: React.FC<{ translation: SubscriberGroupsTranslation }> = ({
  translation
}) => {
  return <div className={styles.headingContainer}>
    <div className={styles.defaultColumn}><span className="asterisk-required">* </span>{translation.name}</div>
    <div className={styles.defaultColumn}><span className="asterisk-required">* </span>{translation.email}</div>
  </div>;
};

